import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateCoolingTower } from '../../redux/ac_central/cooling_tower_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.coolingTower.isDuplicating,
  errorMessage: state.ac.coolingTower.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateCoolingTower(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/CoolingTowerDuplicateModal.js